"use client";

import { ArrowRight, BadgeCheck, Headphones, IdCard } from "@/components/icons";
import ProductHeroRibbon from "@/components/sections/products/shared/hero-ribbon";
import { FREE_TRIAL_URL, FREE_TRIAL_LABEL } from "@/lib/constants";
import { MAINTENANCE_PATH } from "@/lib/maintenance";
import { useMaintenanceMode } from "@/hooks/use-maintenance-mode";
import { useHeroAnnouncementChip } from "@/hooks/use-hero-announcement-chip";

/* The money-back guarantee rides in the benefit row rather than a second row of
   pills, so the hero keeps one line of trust signals like the homepage does. */
const benefits = [
  { label: "KYC required", icon: IdCard },
  { label: "30-day money-back guarantee", icon: BadgeCheck },
  { label: "Premium support", icon: Headphones },
];

export default function MobileProductHero() {
  const maintenanceMode = useMaintenanceMode();
  const trialHref = maintenanceMode ? MAINTENANCE_PATH : FREE_TRIAL_URL;
  const { announcement, onAnnouncementClick } = useHeroAnnouncementChip("mobile-proxies-hero");

  return (
    <ProductHeroRibbon
      headingId="mobile-product-hero-heading"
      headingLine1="4G/5G/LTE Mobile Proxies"
      headingLine2="from $2/GB."
      description="Managed 4G/5G/LTE mobile proxies with city and ASN/ISP targeting, rotating or sticky sessions, and HTTP(S)/SOCKS5 support. Pay per GB from $2/GB, or choose Per Proxy from $59/proxy/month."
      benefits={benefits}
      ctas={[
        {
          label: FREE_TRIAL_LABEL,
          href: trialHref,
          trailingIcon: <ArrowRight size={16} aria-hidden="true" />,
        },
        { label: "Compare Mobile vs. Residential", href: "#compare-proxies" },
      ]}
      announcement={announcement}
      onAnnouncementClick={onAnnouncementClick}
    />
  );
}
